import { IVariant, useVariant as useVariantProxy } from '@unleash/proxy-client-react'
import { useEffect, useRef } from 'react'
import { logExperiment } from './logExperiment'

/**
 * Wraps Unleash proxy useVariant and logs the experiment once when enabled.
 * Prefer this over useFlag for A/B experiments that need payload values.
 */
const useVariant = (flagName: string): Partial<IVariant> => {
  const variant = useVariantProxy(flagName)
  const hasLoggedRef = useRef(false)

  useEffect(() => {
    if (!variant?.enabled || hasLoggedRef.current) return
    hasLoggedRef.current = true

    const webDeviceId =
      typeof window !== 'undefined' ? localStorage.getItem('device_id') || '' : ''
    const uuid =
      typeof window !== 'undefined' ? localStorage.getItem('uuid') || '' : ''

    logExperiment({
      flagName,
      variantName: variant?.name || '',
      context: {
        ...(webDeviceId ? { webDeviceId } : {}),
        ...(uuid ? { uuid } : {}),
      },
    })
  }, [variant?.enabled, variant?.name, flagName])

  return variant
}

export default useVariant
